import { BaseDropDownData, NormalizedDropDown } from '~types'

const foodRestrictionMap = {
  GlutenFriendly: 'Gluten Friendly',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian'
}

const locationMap = {
  EventLevel: 'Event Level',
  MainLevelSection100S: 'Main Level (Section 100s)',
  TerraceLevelSection200S: 'Terrace Level (Section 200s)',
  LowerGallerySection300S400S: 'Lower Gallery (Section 300s, 400s)',
  UpperGallerySection400S: 'Upper Gallery (Section 400s)'
}

export function normalizeTaxonomyData(data?: BaseDropDownData[]): NormalizedDropDown[] {
  if (!data) return []

  return data.map(item => {
    const transformed: NormalizedDropDown = {}

    if (item.dropDownOption === 'foodRestriction' && item.foodRestrictions) {
      transformed.options = item.foodRestrictions.map(restriction => ({
        label: foodRestrictionMap[restriction.value as keyof typeof foodRestrictionMap] || restriction.value,
        value: restriction.value
      }))
    } else if (item.dropDownOption === 'restaurantLocation' && item.restaurantLocations) {
      transformed.options = item.restaurantLocations.map(location => ({
        label: locationMap[location.value as keyof typeof locationMap] || location.value,
        value: location.value
      }))
    }

    transformed.id = item.id
    transformed.dropDownOption = item.dropDownOption
    return transformed
  })
}
